// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Menu-module__Container__fwnrO {
    display: flex;
    flex-direction: column;
    /* TBD: not sure about this. Must check all other usages of the Menu */
    gap: var(--ds-xs);
}
/* \`min-height: 0\` lets it scroll rather than overflow when it is a flex child of
 * a height-capped column. */
.Menu-module__Scrollable__fNwly {
    min-height: 0;
    overflow-y: auto;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Container": `Menu-module__Container__fwnrO`,
	"Scrollable": `Menu-module__Scrollable__fNwly`
};
export default ___CSS_LOADER_EXPORT___;
